import { createMuiTheme } from '@material-ui/core/styles';
var maternaTheme = createMuiTheme({
    palette: {
        primary: { main: '#c30a17' },
        secondary: { main: '#3a3E41' },
    },
});
export default maternaTheme;
//# sourceMappingURL=materna_theme.js.map